/* IDEAL ROUND (copy only, never live): the ONE cart drawer of the ideal store (D1, kit/POLISH-ROUND-1.md).
   Template-agnostic: any template renders snippets/ph-cart-drawer once; this file needs nothing from the product page.
   API (window.phCart): open() loads the cart and opens; add(lines, attrs) adds and opens; close(); render(); isOpen().
     lines: [{ id: variantId, qty: 1, title, v (variant name), m (main price, cents), img }] - title/m/img are only used
     in demo mode (window.__phCartDemo: no request at all, for screenshots); the real cart is read back from /cart.js.
     A line with fictive: true (a set item without a product) goes to the cart as a cart attribute.
   The header bag icon (a[href$="/cart"], #cart-icon-bubble, [data-cart-drawer-toggle]) opens it on every template.
   Shows: reservation countdown, reward bar, the bags, an upsell (the set item; on the product page also another colour
   via phIdeal.upsellAlt), shipping protection (on) and gift wrap, the summary, a short footer (urgency, button with the
   total, trust, payment icons). Rewards, protection, gift wrap: display only, sent as cart attributes. */
(function () {
  'use strict';
  if (window.phCart && window.phCart.v) return;
  var P = window.phIdeal = window.phIdeal || {};
  var doc = document, root = doc.documentElement;
  var W = window.wpPdp = window.wpPdp || {};
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function jsonOf(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var cartEl = $('[data-ph-cart]');
  if (!cartEl) return;
  var K = jsonOf($('#ph-cart-conf')) || {};
  var C = (jsonOf($('#ph-cart-copy')) || {}).cart || {};
  var T = (P.cfg && P.cfg.texts) || {};
  var ICON = {
    check: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    plus: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>',
    minus: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 12h13"/></svg>',
    card: '<svg class="ph-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="6.5" width="17" height="11" rx="2"/><path d="M3.5 10h17M7 14h4"/></svg>'
  };
  var demo = !!window.__phCartDemo;
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pct = K.pct || (P.cfg && P.cfg.pct) || 65, bundle = K.bundle || 15, SB = K.second || { mode: 'pct', cents: 0 };

  /* money like the theme (separators and symbol from a rendered sample) */
  var sample = (P.cfg && P.cfg.moneySample) || '€1.234,56';
  var sep = /1([.,'\s  ]?)234([.,])56/.exec(sample) || [null, '.', ','];
  function money(c) {
    c = Math.round(c); var neg = c < 0; c = Math.abs(c);
    var whole = Math.floor(c / 100), cents = c % 100, s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep[1] || '');
    if (cents) s += sep[2] + (cents < 10 ? '0' : '') + cents;
    return (neg ? '−' : '') + sample.replace(/1[.,'\s  ]?234[.,]56/, s);
  }
  function pin() { try { return !!(P.isPin && P.isPin()); } catch (e) { return false; } }
  function worldPrice(m) { return pin() ? Math.floor(m * pct / 100) : m; }
  function whole(c) { return Math.floor(c / 100) * 100; }
  function parsePrice(t) { var m = String(t || '').match(/(\d+)(?:[.,](\d{2}))?/); return m ? +m[1] * 100 + (m[2] ? +m[2] : 0) : 0; }
  // typed amounts in copy ("25 € statt 49 €") printed like the shop's money format ("€25 statt €49") (QA 26)
  function fixMoney(t) { return /^\D/.test(sample) ? String(t || '').replace(/(\d+(?:,\d{2})?)\s?€/g, '€$1') : String(t || ''); }
  function short(t) { return String(t || '').split(/[:,]| mit | with /)[0].trim(); }
  function first(t) { var s = String(t || ''), i = s.search(/[.!?](\s|$)/); return i > 0 ? s.slice(0, i + 1) : s; }

  var state = { items: [], opts: { protection: true, gift: false } };
  function isOpen() { return !cartEl.hidden; }
  function reserveEnd() {
    var k = 'ph_reserve_end', end = 0;
    try { end = +sessionStorage.getItem(k) || 0; } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + (P.cfg && P.cfg.reserve || 10) * 60000; try { sessionStorage.setItem(k, end); } catch (e) {} }
    return end;
  }
  function tickReserve() {
    if (!isOpen()) return;
    var ms = Math.max(0, reserveEnd() - Date.now()), m = Math.floor(ms / 60000), s = Math.floor(ms / 1000) % 60;
    $$('[data-ph-reserve]', cartEl).forEach(function (el) { el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s; });
  }
  setInterval(function () { if (isOpen()) { tickReserve(); if (P.tick) P.tick(); } }, 1000);
  function open() {
    if (cartEl.parentNode !== doc.body) doc.body.appendChild(cartEl);
    cartEl.hidden = false; root.classList.add('ph-cart-open');
    if (W.syncSticky) W.syncSticky();
    tickReserve(); render();
    var x = $('.ph-cart__x', cartEl); if (x) x.focus();
  }
  function close() { cartEl.hidden = true; root.classList.remove('ph-cart-open'); if (W.syncSticky) W.syncSticky(); }
  function load() {
    if (demo) return Promise.resolve();
    return fetch(routes + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      state.items = (c.items || []).map(function (it) { return { key: it.key, id: it.variant_id, qty: it.quantity, m: it.original_price, title: it.product_title, v: it.variant_title || '', img: it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '' }; });
      var a = c.attributes || {};
      if (a.Set) state.items.push({ key: 'set-fictive', id: 'set-fictive', qty: 1, m: (K.set || {}).m || 0, title: a.Set, v: '', img: '', fictive: true });
      state.opts.protection = a['Versandschutz'] !== 'nein';
      state.opts.gift = a['Geschenkverpackung'] === 'ja';
    }).catch(function () {});
  }
  function demoAdd(lines) {
    lines.forEach(function (ln) {
      var ex = state.items.filter(function (x) { return String(x.id) === String(ln.id); })[0];
      if (ex) ex.qty += ln.qty; else state.items.push({ key: 'demo-' + ln.id, id: ln.id, qty: ln.qty, m: ln.m || 0, title: ln.title || '', v: ln.v || '', img: ln.img || '', fictive: !!ln.fictive });
    });
  }
  function addLines(lines, attrs) {
    if (demo) { demoAdd(lines); return Promise.resolve(); }
    var fict = lines.filter(function (l) { return l.fictive; });
    var real = lines.filter(function (l) { return !l.fictive; });
    if (fict.length) { attrs = attrs || {}; attrs.Set = fict.map(function (l) { return l.title; }).join(', '); }
    var add = real.length ? fetch(routes + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: real.map(function (l) { return { id: Number(l.id), quantity: l.qty || 1 }; }) })
    }) : Promise.resolve();
    return add.then(function () {
      if (!attrs) return;
      return fetch(routes + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
    }).then(load);
  }
  function changeQty(key, d) {
    var it = state.items.filter(function (x) { return x.key === key; })[0]; if (!it) return;
    var q = Math.max(0, it.qty + d);
    if (demo || it.fictive) { it.qty = q; state.items = state.items.filter(function (x) { return x.qty > 0; }); render(); return; }
    fetch(routes + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(load).then(render);
  }
  function upsell() {
    var S = K.set;
    if (S) {
      var sid = String(S.id || 'set-fictive');
      if (!state.items.some(function (x) { return String(x.id) === sid; })) return { id: sid, m: S.m, title: S.title, v: '', img: S.img || '', fictive: !S.id, isSet: true };
    }
    return P.upsellAlt ? P.upsellAlt(state.items) : null;
  }
  function count() { return state.items.reduce(function (n, x) { return n + x.qty; }, 0); }

  function render() {
    var n = count(), items = $('[data-ph-items]', cartEl), prog = $('[data-ph-prog]', cartEl), up = $('[data-ph-up]', cartEl), sum = $('[data-ph-sum]', cartEl);
    var cnt = $('[data-ph-cart-count]', cartEl); if (cnt) cnt.textContent = n ? '(' + n + ')' : '';
    var stops = C.progress || [];
    if (prog) {
      var k = stops.length || 1, reached = 0;
      stops.forEach(function (s, i) { if (n >= s.at) reached = i + 1; });
      var fill = reached ? Math.min(100, Math.round((reached - .5) / k * 100 + (reached === k ? 50 / k : 0))) : 0;
      prog.innerHTML = (C.mix_line ? '<p class="ph-prog__msg">' + esc(C.mix_line) + '</p>' : '') +
        '<div class="ph-prog__bar"><span class="ph-prog__fill" style="width:' + fill + '%"></span></div><div class="ph-prog__stops" style="grid-template-columns:repeat(' + k + ',1fr)">' +
        stops.map(function (s) { return '<span class="ph-prog__stop' + (n >= s.at ? ' is-ok' : '') + '"><i>' + (n >= s.at ? ICON.check : '') + '</i>' + esc(String(s.label).replace(/\s*✓$/, '')) + '</span>'; }).join('') + '</div>';
      prog.hidden = !stops.length;
    }
    var sub = 0, was = 0;
    if (items) items.innerHTML = n ? state.items.map(function (it) {
      var p = worldPrice(it.m) * it.qty; sub += p; was += it.m * it.qty;
      var pic = it.img ? '<img src="' + esc(it.img) + '" alt="" width="80" height="80">' : '<span class="ph-line__tile">' + ICON.card + '</span>';
      return '<div class="ph-line">' + pic + '<div><p class="ph-line__t">' + esc(it.title) + '</p>' + (it.v ? '<p class="ph-line__v">' + esc(it.v) + '</p>' : '') +
        '<div class="ph-line__row"><span class="ph-qty"><button type="button" data-ph-q="-1" data-key="' + esc(it.key) + '" aria-label="−">' + ICON.minus + '</button><span>' + it.qty +
        '</span><button type="button" data-ph-q="1" data-key="' + esc(it.key) + '" aria-label="+">' + ICON.plus + '</button></span><span class="ph-line__p">' + (pin() ? '<s>' + money(it.m * it.qty) + '</s>' : '') + money(p) + '</span></div></div></div>';
    }).join('') : '<p class="ph-cart__empty">' + esc(C.empty || '') + '</p>';
    var u = n ? upsell() : null;
    if (up) {
      var subT = C.upsell_sub || '';
      if (P.nl && /leder|leather/i.test(subT)) subT = '';
      var line = fixMoney(u ? (u.isSet ? subT : (C.upsell_colour || subT)) : '');
      var price = u ? (u.isSet ? '' : '<small class="ph-up__p"><s>' + money(worldPrice(u.m)) + '</s> <b>' + money(SB.mode === 'fixed' ? Math.max(0, worldPrice(u.m) - (SB.cents || 0)) : whole(worldPrice(u.m) * (1 - bundle / 100))) + '</b></small>') : '';
      var pic = u && u.img ? '<img src="' + esc(u.img) + '" alt="" width="64" height="64">' : '<span class="ph-up__tile">' + ICON.card + '</span>';
      up.innerHTML = u ? '<p class="ph-up__h">' + esc(C.upsell_heading || '') + '</p><div class="ph-up__card">' + pic +
        '<div><b>' + esc(u.title) + (u.v ? ' · ' + esc(u.v) : '') + '</b><small class="ph-up__s">' + esc(line) + '</small>' + price +
        '<button type="button" class="ph-up__add" data-ph-up-add>' + ICON.plus + '<span>' + esc(C.upsell_add || T.add || '') + '</span></button></div></div>' : '';
    }
    // the 2nd-bag reward: a fixed amount per order (Elsaria: the live automatic discount) or -x % on both bags (Tirana)
    var reward = 0, bags = [];
    state.items.forEach(function (it) { if (it.fictive) return; for (var i = 0; i < it.qty; i++) bags.push(worldPrice(it.m)); });
    if (bags.length >= 2) {
      if (SB.mode === 'fixed') reward = SB.cents || 0;
      else { var sb = bags.reduce(function (a, b) { return a + b; }, 0); reward = sb - whole(sb * (1 - bundle / 100)); }
    }
    var pp = 0, gp = 0;
    $$('[data-ph-opt]', cartEl).forEach(function (o) {
      var key = o.getAttribute('data-ph-opt'), c = parsePrice(o.getAttribute('data-price'));
      o.checked = !!state.opts[key];
      var em = o.parentNode.querySelector('[data-ph-opt-price]'); if (em) em.textContent = '+' + money(c);
      if (o.checked) { if (key === 'gift') gp = c; else pp = c; }
    });
    var total = sub - reward + pp + gp, saved = (was - sub) + reward;
    if (sum) sum.innerHTML = n ? '<p><span>' + esc(C.subtotal || T.subtotal || '') + '</span><span>' + money(sub) + '</span></p>' +
      (reward ? '<p class="is-save"><span>' + esc((stops[1] && stops[1].label) || '') + '</span><span>−' + money(reward) + '</span></p>' : '') +
      (pp ? '<p><span>' + esc(short((C.protection || {}).label)) + '</span><span>' + money(pp) + '</span></p>' : '') +
      (gp ? '<p><span>' + esc(short((C.gift_wrap || {}).label)) + '</span><span>' + money(gp) + '</span></p>' : '') +
      (saved > 0 ? '<p class="is-save"><span>' + esc(C.saved || T.saved || '') + '</span><span>' + money(saved) + '</span></p>' : '') +
      '<p class="is-total"><span>' + esc(C.total || T.total || '') + '</span><span>' + money(total) + '</span></p>' : '';
    var tot = $('[data-ph-total]', cartEl); if (tot) tot.textContent = n ? money(total) : '';
    var co = $('[data-ph-checkout]', cartEl); if (co) co.classList.toggle('is-disabled', !n);
    var ur = $('[data-ph-urg]', cartEl); if (ur && !ur.getAttribute('data-done')) { ur.textContent = first(ur.textContent); ur.setAttribute('data-done', '1'); }
    if (P.tick) P.tick(); tickReserve();
  }

  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var hb = t.closest('a[href$="/cart"], #cart-icon-bubble, [data-cart-drawer-toggle]');
    if (hb && !t.closest('[data-ph-cart]')) { e.preventDefault(); e.stopPropagation(); load().then(open); return; }
    if (!t.closest('[data-ph-cart]')) return;
    if (t.closest('[data-ph-cart-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-ph-q]');
    if (q) { e.preventDefault(); changeQty(q.getAttribute('data-key'), +q.getAttribute('data-ph-q')); return; }
    if (t.closest('[data-ph-up-add]')) {
      e.preventDefault();
      var u = upsell(); if (u) addLines([{ id: u.id, qty: 1, m: u.m, title: u.title, v: u.v, img: u.img, fictive: u.fictive }]).then(render);
    }
  }, true);
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  cartEl.addEventListener('change', function (e) {
    var o = e.target.closest && e.target.closest('[data-ph-opt]'); if (!o) return;
    state.opts[o.getAttribute('data-ph-opt')] = o.checked; render();
    if (!demo) fetch(routes + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Versandschutz: state.opts.protection ? 'ja' : 'nein', Geschenkverpackung: state.opts.gift ? 'ja' : 'nein' } }) });
  });

  window.phCart = {
    v: 1, isOpen: isOpen, render: render, close: close, state: state,
    open: function () { return load().then(open); },
    add: function (lines, attrs) { return addLines(lines || [], attrs).then(open); }
  };
  W.openDrawer = function () { load().then(open); };
  P.openCart = window.phCart.open;
})();
